module.exports = __webpack_public_path__ + "img/電気回路_3_5.19d231c8.png";